import React from 'react';
import styled from 'styled-components';

import sideBrandImg from 'images/sideBrand.png';

;export const RED = '#E23544';
export const BLACK = 'rgb(34,31,32)';
export const YELLOW = '#F1C734';

export const MOBILE_MAX = '819px';
export const DESKTOP_MIN = '820px';

const PreviewLayout = styled.div`
  display: flex;
  position: relative;
  background: #000;
  background: ${props => props.dark ? '#000' : YELLOW};
  width: 750px;
  background-size: cover;
  &:before {
    content: ' ';
    padding-top: 100%;
    display: block;
  }
`;
const PreviewInner = styled.div`
  position: absolute;
  top: 5%;
  left: 25%;
  width: 75%;
  height: 90%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

`;

const PreviewSideBrand = styled.div`
  position: absolute;
  top: 5%;
  left: 5%;
  height: 90%;
  width: 50%;
  img {
    height: 100%;
    width: auto;
  }
`;

const Type = styled.div`
  position: relative;
`;
const TypeInput = styled.div`
  position: relative;
  text-transform: uppercase;
  font-size: 88px;
  /*line-height: 1.22;*/
  color: ${BLACK};
  width: 100%;
  border: 0;
  padding: 0;
  margin-top: 5px;
  margin-bottom: 5px;
  background: none;
  &::placeholder {
    color: ${BLACK};
  }
  &::selection {
    background: ${BLACK};
  }
  
  &:focus {
    outline: none;
    color: ${RED};
  }
`;

const PreviewFooter = styled.div`
  position: relative;
  display: flex;
  font-size: 15px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  span {
    text-transform: uppercase;
    text-decoration: none;
    position: relative;
    letter-spacing: 0.04em;
  }
  img {
    margin-left: 2vw;
    width: 12%;
    height: auto !important;
  }
`;

const PreviewArtwork = ({words, placeholders, bgColor}) => {
  return (
    <PreviewLayout style={{background: bgColor}}>
      <PreviewSideBrand>
      <img alt='' src={sideBrandImg} />
      </PreviewSideBrand>
      <PreviewInner>
        
        <Type>
          <TypeInput placeholder={placeholders.word1}>{words.word1}</TypeInput>
          <TypeInput placeholder={placeholders.word2}>{words.word2}</TypeInput>
          <TypeInput placeholder={placeholders.word3}>{words.word3}</TypeInput>
          <TypeInput placeholder={placeholders.word4}>{words.word4}</TypeInput>
          <TypeInput placeholder={placeholders.word5}>{words.word5}</TypeInput>
          <TypeInput placeholder={placeholders.word6}>{words.word6}</TypeInput>
        </Type>
        <PreviewFooter>
          <span>THIS IS MY AMERICA</span>
        </PreviewFooter>
      </PreviewInner>
    </PreviewLayout>
  );
}


export default PreviewArtwork;


// WEBPACK FOOTER //
// ./src/PreviewArtwork.js